import Icon from '@ant-design/icons'
import type { customIconProps } from './types'

function editSVG(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.1675 0.879988L11.7244 2.14712C11.8748 2.29359 11.959 2.49493 11.9578 2.7048C11.9566 2.91468 11.87 3.11503 11.718 3.25977L10.535 4.7006L6.50863 9.61304C6.43891 9.69513 6.34507 9.75311 6.24047 9.77874L4.15286 10.259C3.87586 10.2705 3.63699 10.0662 3.60535 9.79075L3.703 7.73115C3.71024 7.626 3.75187 7.52615 3.82147 7.44699L7.6741 2.75227L9.03089 1.09691C9.2945 0.738094 9.79032 0.64347 10.1675 0.879988Z"
        stroke="#002244"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.75 12.0001C0.335786 12.0001 0 12.3358 0 12.7501C0 13.1643 0.335786 13.5001 0.75 13.5001V12.7501V12.0001ZM11.7163 13.5001C12.1306 13.5001 12.4663 13.1643 12.4663 12.7501C12.4663 12.3358 12.1306 12.0001 11.7163 12.0001V12.7501V13.5001ZM8.36949 2.47157C8.21445 2.08747 7.77739 1.90177 7.39329 2.05681C7.00918 2.21185 6.82349 2.64891 6.97852 3.03301L7.67401 2.75229L8.36949 2.47157ZM10.7001 5.43459C11.1042 5.34331 11.3577 4.94179 11.2664 4.53776C11.1752 4.13372 10.7736 3.88018 10.3696 3.97146L10.5349 4.70302L10.7001 5.43459ZM0.75 12.7501V13.5001H11.7163V12.7501V12.0001H0.75V12.7501ZM7.67401 2.75229L6.97852 3.03301C7.17126 3.51051 7.56556 4.18923 8.15609 4.71436C8.75977 5.25119 9.63332 5.67559 10.7001 5.43459L10.5349 4.70302L10.3696 3.97146C9.91633 4.07386 9.51954 3.91952 9.15286 3.59345C8.77302 3.25568 8.49694 2.78734 8.36949 2.47157L7.67401 2.75229Z"
        fill="#002244"
      />
    </svg>
  )
}

export default function editIcon(props: customIconProps) {
  return <Icon component={editSVG} {...props} onClick={props.onClick} />
}
